import { module } from 'modujs';
import Swiper, {Navigation, Pagination, Autoplay, EffectFade} from 'swiper/bundle';
import { isMobile } from 'mobile-device-detect';

export default class extends module {

    constructor(m) {
        super(m);


        if( isMobile && this.el.dataset.mode === 'desktop' ){
            return;
        }


        this.changeSlide = [...this.$( 'change-slide' )];
        this.activeSlide = this.changeSlide[0];

        this.args =  { effect: 'fade', loop: true, };





        if( this.$( 'pagination' ).length ){
            this.args.pagination = {
                el: this.$( 'pagination' )[0],
                    clickable: true,
                    renderBullet: function (index, className) {
                    return '<span class="w-[40px] h-[40px] hd:w-40 hd:h-40   block flex items-center justify-center group cursor-pointer ' + className + '">' +
                        '<span class="w-[33px] h-[33px] hd:w-[3.3rem] hd:h-[3.3rem] text-16 font-semibold flex items-center justify-center border border-white text-white  rounded-full block group-[.swiper-pagination-bullet-active]:bg-white group-[.swiper-pagination-bullet-active]:text-black  transition">'
                        +  ( index +1 ) + '</span>'
                        +'</span>';
                },
            }
        }
        this.swiper = new Swiper( this.$( 'swiper' )[0], this.args );
        this.swiper.on('slideChange',  e => {
            let index = e.activeIndex -1;
            if( index < 0 ) index = this.changeSlide.length -1;
            this.activeSlide.classList.remove( 'active' );
            this.activeSlide = this.changeSlide[ Math.abs(index ) % this.changeSlide.length ];
            this.activeSlide.classList.add( 'active' );

        });

        this.changeSlide.forEach( item => {
           item.addEventListener( 'mouseenter', e => {

               this.swiper.slideTo(e.currentTarget.dataset.index);
           });

        });
    }

}
